import { useCallback } from 'react'
import {
  useCreateCollectionMutation,
  type CreateCollectionMutationVariables,
} from 'domains/collections/api'

export const useCreateCollection = () => {
  const [triggerMutation, { data, loading, error, called }] = useCreateCollectionMutation()

  const createCollection = useCallback(
    ({
      collectionName,
      startDate,
      endDate,
      parentId,
      retailerIds,
      collectionType,
      active,
      image,
      headerData,
      storefrontBannerData,
      subjectsData,
      childrenIds,
    }: CreateCollectionMutationVariables) => {
      triggerMutation({
        variables: {
          collectionName,
          startDate,
          endDate,
          parentId,
          retailerIds,
          collectionType,
          active,
          image,
          headerData,
          storefrontBannerData,
          subjectsData,
          childrenIds,
        },
      })
    },
    [triggerMutation]
  )

  return {
    createCollection,
    apiCalled: called,
    apiResult: data,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
